<ng-container *ngIf="supplements as supplements">
  <h1 class="aya-title">Supplementary Options</h1>
  <p class="aya-subtitle">{{ supplements?.supplementaryInfo }}</p>
  <p class="aya-subtitle">Courses are subject to regulatory approval and accreditation</p>
  <div class="aya-supplements">
    <lx-price-lists-portal-aya-supplement-items title="Tuition upgrades:" [items]="supplements?.tuitionUpgrades"></lx-price-lists-portal-aya-supplement-items>
    <lx-price-lists-portal-aya-supplement-items
      title="Accommodation supplement:"
      [items]="supplements?.accommodation"
    ></lx-price-lists-portal-aya-supplement-items>
    <lx-price-lists-portal-aya-supplement-items title="General fees:" [items]="supplements?.generalFees"></lx-price-lists-portal-aya-supplement-items>
  </div>
</ng-container>
